<template>
  <div class="jr">
    <div class="head-list">
      <div v-for="(item, index) in headList" :key="index">
        <div class="num">{{item.value || 0 | formatNumber}}</div>
        <div class="text">{{item.name}}{{item.unit}}</div>
      </div>
    </div>
    <div class="content">
      <div class="top"><div class="icon"></div>授信记录</div>
      <div class="title">金融机构：{{page1.total}}家</div>
      <div>
        <div class='ux-tabs tabs' style="margin:0 40px;
          width:calc(100% - 80px);margin-top:16px;min-height:100px">
          <div class="ux-filter-records filter-records">
            <div class='content-list'>
              <el-table
                class="table ux-dark-el-table"
                :data="tableData1"
                max-height="550"
                empty-text="暂无数据"
                element-loading-spinner="el-icon-loading">
                  <el-table-column v-for="(props, i) in tableHeader1" :label='props.label' align="center" :key="i" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div v-if="props.type">
                        {{scope.$index + 1}}
                      </div>
                      <div v-else class="text">{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
            <div class='pages'>
              <span>共 {{ page1.total }} 条数据</span>
              <el-pagination
                class="ux-dark-el-pagination"
                small
                background
                layout="prev, pager, next"
                :current-page="page1.current"
                :page-size="page1.size"
                :total="page1.total"
                @size-change="sizeChange1"
                @current-change="currentChange1"
              />
              <pagination @currentChange="currentChange1" @sizeChange="sizeChange1"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="top"><div class="icon"></div>放贷记录</div>
      <div>
        <div class='ux-tabs tabs' style="margin:0 40px;
          width:calc(100% - 80px);margin-top:16px;min-height:100px">
          <div class="ux-filter-records filter-records">
            <div class='content-list'>
              <el-table
                class="table ux-dark-el-table"
                max-height="550"
                :data="tableData2"
                empty-text="暂无数据"
                element-loading-spinner="el-icon-loading">
                  <el-table-column v-for="(props, i) in tableHeader2" :label='props.label' align="center" :key="i" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div v-if="props.type">
                        {{scope.$index + 1}}
                      </div>
                      <div v-else class="text">{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
            <div class='pages'>
              <span>共 {{ page2.total }} 条数据</span>
              <el-pagination
                class="ux-dark-el-pagination"
                small
                background
                layout="prev, pager, next"
                :current-page="page2.current"
                :page-size="page2.size"
                :total="page2.total"
                @size-change="sizeChange2"
                @current-change="currentChange2"
              />
              <pagination @currentChange="currentChange2" @sizeChange="sizeChange2"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="top"><div class="icon"></div>还款记录</div>
      <div>
        <div class='ux-tabs tabs' style="margin:0 40px;
          width:calc(100% - 80px);margin-top:16px;min-height:100px">
          <div class="ux-filter-records filter-records">
            <div class='content-list'>
              <el-table
                class="table ux-dark-el-table"
                :data="tableData3"
                empty-text="暂无数据"
                max-height="550"
                element-loading-spinner="el-icon-loading">
                  <el-table-column v-for="(props, i) in tableHeader3" :label='props.label' align="center" :key="i" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div v-if="props.type">
                        {{scope.$index + 1}}
                      </div>
                      <div v-else class="text">{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
            <div class='pages'>
              <span>共 {{ page3.total }} 条数据</span>
              <el-pagination
                class="ux-dark-el-pagination"
                small
                background
                layout="prev, pager, next"
                :current-page="page3.current"
                :page-size="page3.size"
                :total="page3.total"
                @current-change="currentChange3"
              />
              <pagination @currentChange="currentChange3" @sizeChange="sizeChange3"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
import apiPath from '@config/api.json'
const {mapState, mapMutations} = require('vuex')
const approvalStatusJson = {
  '1': '审批中',
  '8': '通过',
  '16': '拒绝',
  '32': '已确认（已授信）',
  '64': '驳回'
}
const isLockList = {
  '1': '是',
  '0': '否'
}
const creditTypeList = {
  '1': '票据授信',
  '2': '信用授信',
  '3': '保理授信-循环',
  '4': '保理授信-单笔',
  '5': '权证申请',
  '6': '额度权证申请',
  '7': '资产数字化申请',
  '8': '跨境电商',
  '9': '跨境电商代采'
}
const serviceTypeJson = {
  'FA': '国际贸易供应链',
  'DI': '国内贸易供应链金融',
  'EC': '跨境电商供应链',
  'DC': '跨境电商代采'
}
const loanTypeJson = {
  '0': '提前贴',
  '1': '到期贴'
}

export default {
  components: {
    pagination
  },
  props: ['info'],
  data () {
    return {
      tableHeader1: [
        {
          type: 'index',
          label: '序号'
        },
        {
          prop: 'platform',
          label: '平台名称'
        },
        {
          prop: 'orgNo',
          label: '授信编号'
        },
        {
          prop: 'serviceType',
          label: '产品类型'
        },
        {
          prop: 'creditType',
          label: '授信类型'
        },
        {
          prop: 'applicationDate',
          label: '申请时间'
        },
        {
          prop: 'approvalStatus',
          label: '审批状态'
        },
        {
          prop: 'isEnable',
          label: '是否锁定'
        }
      ],
      tableData1: [],
      page1: {
        current: 1,
        size: 10,
        total: 0
      },
      page2: {
        current: 1,
        size: 10,
        total: 0
      },
      page3: {
        current: 1,
        size: 10,
        total: 0
      },
      tableHeader2: [
        {
          type: 'index',
          label: '序号'
        },
        {
          prop: 'platform',
          label: '平台名称'
        },
        {
          prop: 'customerName',
          label: '企业名称'
        },
        {
          prop: 'bankLoanNo',
          label: '贷款编号'
        },
        {
          prop: 'serviceType',
          label: '产品类型'
        },
        {
          prop: 'loanType',
          label: '放款类型'
        },
        {
          prop: 'applyAmount',
          label: '申请贷款金额（元）'
        },
        {
          prop: 'applicationDate',
          label: '申请时间'
        },
        {
          prop: 'approvalStatus',
          label: '放款状态'
        },
        {
          prop: 'isLock',
          label: '是否锁定'
        }
      ],
      tableData2: [],
      tableHeader3: [
        {
          type: 'index',
          label: '序号'
        },
        {
          prop: 'repayNo',
          label: '还款编号'
        },
        {
          prop: 'repayDate',
          label: '还款日期'
        },
        {
          prop: 'serviceType',
          label: '产品类型'
        },
        {
          prop: 'customerName',
          label: '企业名称'
        },
        {
          prop: 'pendingRepayAmount',
          label: '还款金额（元）'
        }
      ],
      tableData3: [],
      filter: {
        sortParam: '',
        searchParam: ''
      },
      headList: [

      ]
    }
  },

  computed: {
    ...mapState({
      searchDate: (state) => {
        return state.home.searchDate
      }
    })
  },

  watch: {
    searchDate: function (n) {
      this.init()
    }
  },

  created () {
    // this.setLanguageMsg(this.lan)
  },

  mounted () {
    this.init()
  },

  methods: {
    ...mapMutations({}),
    init () {
      // 授信统计
      this.loadEnterpriseLoans()
      this.getList1()
      this.getList2()
      this.getList3()
    },
    // 授信统计
    loadEnterpriseLoans () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.jygl.getEnterpriseLoans}${this.info.customerNo}`
      }).then(res => {
        const dataInfo = res.data || {}
        this.headList = [
          {
            name: '授信金额',
            value: dataInfo.creditAmount ? (dataInfo.creditAmount / 10000).toFixed(2) : '0',
            unit: '（万元）'
          }, {
            name: '现有贷款',
            value: dataInfo.loanBalance ? (dataInfo.loanBalance / 10000).toFixed(2) : '0',
            unit: '（万元）'
          }, {
            name: '累计贷款',
            value: dataInfo.loanAmount ? (dataInfo.loanAmount / 10000).toFixed(2) : '0',
            unit: '（万元）'
          }, {
            name: '剩余授信',
            value: dataInfo.creditBalance ? (dataInfo.creditBalance / 10000).toFixed(2) : '0',
            unit: '（万元）'
          }, {
            name: '逾期金额',
            value: dataInfo.overdueInterests ? (dataInfo.overdueInterests / 10000).toFixed(2) : '0',
            unit: '（万元）'
          }
        ]
      })
    },
    getList1 () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.jr.getEnterpriseDiscountCredit}`,
        data: {
          'companyName': this.info.companyName,
          pageNum: this.page1.current,
          pageSize: this.page1.size,
          searchDate: this.searchDate,
          customerNo: this.info.customerNo
        }
      }).then(res => {
        const dataInfo = res.data || {}
        const dataList = dataInfo.list || {}
        let getList = dataList.records || []
        getList.map(item => {
          item.isEnable = isLockList[item.isEnable + '']
          item.approvalStatus = approvalStatusJson[item.approvalStatus + '']
          item.creditType = creditTypeList[item.creditType + '']
          item.serviceType = serviceTypeJson[item.serviceType + '']
        })
        this.page1.total = dataList.total
        this.tableData1 = getList
      })
    },
    getList2  () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.jr.getEnterpriseDiscountLoan}`,
        data: {
          'companyName': this.info.companyName,
          pageNum: this.page2.current,
          pageSize: this.page2.size,
          searchDate: this.searchDate,
          customerNo: this.info.customerNo
        }
      }).then(res => {
        const dataInfo = res.data || {}
        let getList = dataInfo.records || []
        getList.map(item => {
          item.isLock = isLockList[item.isLock + '']
          item.approvalStatus = approvalStatusJson[item.approvalStatus + '']
          item.creditType = creditTypeList[item.creditType + '']
          item.serviceType = serviceTypeJson[item.serviceType + '']
          item.loanType = loanTypeJson[item.loanType + '']
        })
        this.page2.total = dataInfo.total
        this.tableData2 = getList
      })
    },
    getList3 () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.jr.getEnterpriseDiscountRepayBank}`,
        data: {
          'companyName': this.info.companyName,
          pageNum: this.page3.current,
          pageSize: this.page3.size,
          searchDate: this.searchDate,
          customerNo: this.info.customerNo
        }
      }).then(res => {
        const dataInfo = res.data || {}
        let getList = dataInfo.records || []
        getList.map(item => {
          item.serviceType = serviceTypeJson[item.serviceType + '']
        })
        this.page3.total = dataInfo.total
        this.tableData3 = getList
      })
    },
    currentChange1 (e) {
      this.page1.current = e
      this.getList1()
    },
    currentChange2 (e) {
      this.page2.current = e
      this.getList2()
    },
    currentChange3 (e) {
      this.page3.current = e
      this.getList3()
    },
    sizeChange1 (e) {
      this.page1.current = 1
      this.page1.size = e
      this.getList1()
    },
    sizeChange2 (e) {
      this.page2.current = 1
      this.page2.size = e
      this.getList2()
    },
    sizeChange3 (e) {
      this.page3.current = 1
      this.page3.size = e
      this.getList3()
    }
  }
}
</script>

<style lang="scss" scoped>
  .jr{
    .head-list{
      display: flex;
      margin-top: 30px;
      margin-bottom: 24px;
      justify-content: space-between;
      padding: 0 150px;
      color:#fff;
      font-size:24px;
      .num{
        color: rgb(71,166,234);
        font-size:24px;
        line-height: 40px;
        text-align: center;
      }
      .text{
        font-size:18px;
        line-height: 24px;
      }
    }
    .content{
      border: 1px solid rgb(71,166,234);
      border-radius: 6px;
      padding: 16px 20px 32px 20px;
      margin:0 32px 16px 32px;
      .top{
        display: flex;
        font-size:18px;
        .icon{
          width: 20px;
          height: 20px;
          border-radius: 4px;
          background: rgb(71,166,234);
          margin-right:16px;
        }
      }
      .title{
        text-align: center;
        font-size:18px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/jr.vue